import { IBrandCategory } from "../../../Models/IBrandCategory";
import { IBaseAction } from "../Actions/BaseAction";

export type GetAllCategoriesInitiateAction = IBaseAction<null>;
export type GetAllCategoriesSuccessAction = IBaseAction<IBrandCategory[]>;
export type GetAllCategoriesFailureAction = IBaseAction<IBrandCategory[]>;
export type SetLoadingCategoriesAction = IBaseAction<boolean>;

export type CategoryActionType = 
    GetAllCategoriesInitiateAction |
    GetAllCategoriesSuccessAction | 
    GetAllCategoriesFailureAction |
    SetLoadingCategoriesAction;

export const GET_ALL_CATEGORIES_INITIATE = "GET_ALL_CATEGORIES_INITIATE";
export const GET_ALL_CATEGORIES_SUCCESS = "GET_ALL_CATEGORIES_SUCCESS";
export const GET_ALL_CATEGORIES_FAILURE = "GET_ALL_CATEGORIES_FAILURE";
export const SET_LOADING_CATEGORIES = "SET_LOADING_CATEGORIES";
